<div #containerElement class="page-container">
    <div #contentElement class="page-content" [innerHTML]="htmlContent | safeURL"></div>
</div>